import React, { FC } from "react";
import Posts from "./Posts";
import { ArticleType } from "../../models/article.model";


interface IContentProps {
  posts?: ArticleType[];
  handleBookmark: (post: ArticleType) => void;
  handleRemoveBookmark: (post: ArticleType) => void;
}


const Content: FC<IContentProps> = ({ posts, handleBookmark, handleRemoveBookmark }) => {
  return (
    <div className="blog-content-stack">
      <Posts posts={posts} handleBookmark={handleBookmark} handleRemoveBookmark={handleRemoveBookmark} />
    </div>
  );
}

export default Content;